export default {
  // appName: "ZEREZ",
  search: "Search...",
};
